import {
  GET_OUTLETS,
  DELETE_OUTLET,
  ADD_OUTLET,
  UPDATE_OUTLET,
} from '../../actions/types';

const initalizeState = {
  outlets:   [],
  loading:   true,
  error:     {},
  updatedAt: new Date(),
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_OUTLETS:
      return {
        ...state,
        outlets: payload.outlets,
        loading: false,
      };
    case ADD_OUTLET:
      return {
        ...state,
        outlets:   [payload.outlet, ...state.outlets],
        loading:   false,
        updatedAt: new Date(),
      };
    case UPDATE_OUTLET:
      return {
        ...state,
        outlets:   [payload, ...state.outlets.filter((outlet) => outlet.id !== payload.id)],
        loading:   false,
        updatedAt: new Date(),
      };
    case DELETE_OUTLET:
      return {
        ...state,
        outlets:   state.outlets.filter((outlet) => outlet.id !== payload),
        loading:   false,
        updatedAt: new Date(),
      };
    default:
      return state;
  }
}
